import React from 'react';
import { EntitySettings } from 'screens/Admin/components';

const Settings = ({ story, closeModal, visible, setVisible, loading }) => {
  if (!story) return null;

  const settings = [
    {
      text: 'Remove story',
      icon: 'delete',
      onClick: () => setVisible('remove'),
      isDisabled: loading
    }
  ];

  return (
    <React.Fragment>
      <EntitySettings options={settings} />
    </React.Fragment>
  );
};

export default Settings;
